import en from './en';
import ja from './ja';
import bn from './bn';
import bur from './bur';
import hi from './hi';
import id from './id';
import kh from './kh';
import lo from './lo';
import mn from './mn';
import ne from './ne';
import tl from './tl';
import th from './th';
import vi from './vi';
import lk from './lk';


export default {
    en: {
        message: en
    },
    ja: {
        message: ja
    },
    bn: {
        message: bn
    },
    bur: {
        message: bur
    },
    hi: {
        message: hi
    },
    id: {
        message: id
    },
    kh: {
        message: kh
    },
    lo: {
        message: lo
    },
    mn: {
        message: mn
    },
    ne: {
        message: ne
    },
    tl: {
        message: tl
    },
    th: {
        message: th
    },
    vi: {
        message: vi
    },
    lk: {
        message: lk
    },
}
